const KEYS = {
  desktop: 'mox-grid-density-columns',
  mobile: 'mox-grid-density-columns-mobile',
};
const DEFAULTS = { desktop: '4', mobile: '2' };

function applyColumns(viewport, columns) {
  const resultsList = document.querySelector('results-list');
  if (resultsList) {
    const attr = viewport === 'mobile' ? 'data-mox-columns-mobile' : 'data-mox-columns';
    resultsList.setAttribute(attr, columns);
  }

  document.querySelectorAll(`.mox-grid-density__btn[data-viewport="${viewport}"]`).forEach((btn) => {
    const active = btn.dataset.columns === String(columns);
    btn.classList.toggle('mox-grid-density__btn--active', active);
    btn.setAttribute('aria-pressed', String(active));
  });
}

// Restore saved preferences on page load
applyColumns('desktop', sessionStorage.getItem(KEYS.desktop) || DEFAULTS.desktop);
applyColumns('mobile', sessionStorage.getItem(KEYS.mobile) || DEFAULTS.mobile);

// Handle button clicks
document.addEventListener('click', (event) => {
  const btn = event.target.closest('.mox-grid-density__btn');
  if (!btn || !btn.dataset.viewport) return;

  const { viewport, columns } = btn.dataset;
  sessionStorage.setItem(KEYS[viewport], columns);
  applyColumns(viewport, columns);
});
